import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getRiderProfileCompleteness } from "../api/client";

/**
 * Rider profile-completeness nudge. Below 70%, renders a persistent banner
 * with no dismiss option — it's meant to be unavoidable until the rider
 * actually completes their KYC, so it re-fetches and re-renders on every
 * page that includes it rather than remembering a "dismissed" state.
 *
 * Once at/above 70%, the banner disappears everywhere. Pass
 * `showOnComplete` (used on the Dashboard only) to instead show a small
 * "Profile: X%" indicator once complete.
 */
export default function RiderProfileStatus({ showOnComplete = false }) {
  const [percent, setPercent] = useState(null);

  useEffect(() => {
    let cancelled = false;
    getRiderProfileCompleteness()
      .then(({ data }) => { if (!cancelled) setPercent(data.percent); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);

  if (percent === null) return null;

  if (percent < 70) {
    return (
      <div className="quote-box" style={{ marginBottom: "16px", background: "var(--warning-bg)", borderColor: "var(--warning-border)" }}>
        <p style={{ fontWeight: 700, color: "var(--warning-hover)" }}>
          ⚠️ Your profile is {percent}% complete
        </p>
        <p className="hint" style={{ marginTop: "4px" }}>
          Complete your KYC details to keep dispatching — this needs to reach at least 70% before it stops showing.
        </p>
        <Link to="/rider/profile">
          <button type="button" style={{ marginTop: "10px" }}>Complete My Profile</button>
        </Link>
      </div>
    );
  }

  if (showOnComplete) {
    return (
      <div className="rider-info-chip" style={{ marginBottom: "16px", display: "inline-flex" }}>
        ✓ Profile {percent}% complete
      </div>
    );
  }

  return null;
}
